import { EntityUIState, RetryApiAlert } from '@hevoio/hevo-ui-toolkit';
import AiResponseContainerLoader from './AiResponseContainerloader';
import AiResponseContent from './AiResponseContent';
import { AIResponse } from '../../interfaces/aiResponse';
import { IconHeadset } from '@tabler/icons-react';
import { AxiosError } from 'axios';
import { QueryType } from '../../interfaces/query';

const ISSUE_LOADING_TITLE = 'Searching for the best solution…';
const QUESTION_LOADING_TITLE = 'Looking for an answer…';

export default function AiResponseContainer({
  queryType,
  response,
  onTalkToSupport,
  uiState,
  error,
  onResolveIssue
}: {
  queryType: QueryType;
  response: AIResponse;
  onTalkToSupport: () => void;
  uiState: EntityUIState;
  error: AxiosError<unknown, any>;
  onResolveIssue: () => void;
}) {
  const showLoading = uiState === EntityUIState.LOADING;
  const showError = uiState === EntityUIState.ERRORED && error && error.name !== 'CanceledError';
  const showAiResponseContainer = uiState === EntityUIState.IDLE && response;
  
  

  return (
    <div className='h-100 overflow-auto'>
      {showLoading ? <AiResponseContainerLoader title={queryType === QueryType.ISSUE ? ISSUE_LOADING_TITLE : QUESTION_LOADING_TITLE} /> : null}
      
      {showError ? (
        <div className='d-flex justify-center align-items-center h-100 p-4'>
        <RetryApiAlert
          title='Sorry! We couldn’t Find an answer to your question'
          subTitle='You can either retry or talk to live chat support'
          primaryCTAProps={{
            onClick: onTalkToSupport,
            SVGIcon: IconHeadset,
            variation: 'outline',
            palette: 'secondary',
            className: 'text-secondary',
            iconClassName: 'icon-size-3',
            children: 'Talk to Support'
          }}
          secondaryCTAProps={null}  
          />
          </div>
      ): null}
      
      {showAiResponseContainer ? (
        <AiResponseContent
          response={response}
          onTalkToSupport={onTalkToSupport}
          onResolveIssue={onResolveIssue}
        />
      ):null}
    </div>
  );
}
